module.exports = __webpack_public_path__ + "img/PrintFeed.f7b38321.png";